import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { Feedback } from "@dreamhub/designsystem/icons";
import { IconColor } from "@/components/ui/icon-container";
import {
  IconButton,
  IconButtonSize,
  IconButtonVariant
} from "@/components/ui/icon-button";

interface FeedbackButtonProps {
  tooltip: string;
  className?: string;
  idContext?: string;
  iconColor?: IconColor;
  size?: IconButtonSize;
  variant?: IconButtonVariant;
}

const FeedbackButton = ({
  tooltip,
  className,
  idContext,
  iconColor,
  size,
  variant = "iconNoBg"
}: FeedbackButtonProps) => {
  const buttonId = idContext ? `feedback-${idContext}` : "feedback";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <IconButton
          variant={variant}
          id={buttonId}
          data-test={buttonId}
          className={className}
          iconColor={iconColor}
          size={size}
        >
          <Feedback />
        </IconButton>
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  );
};

export default FeedbackButton;
